export default __webpack_public_path__ + "static/media/laporan-surat jalan-kasir.3a36053b.png";